import React, { useEffect } from 'react';
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import { DatePicker } from "antd"
import dayjs from "dayjs"
const { RangePicker } = DatePicker
import { styled } from '@mui/system';
import { useGetBusinessUnitGlobalFilter, useGetSAupplierNameGlobalFilter } from '../../hooks/Reporting';

const ReportingGlobalFilters = ({
  globalRptFilters,
  handleClear,
  handleGlobalRptFilters,
  BUlist,
  SuppliersList,
  onChange
}) => {
  // State to control Business Unit select open state
  const [buSelectOpen, setBuSelectOpen] = React.useState(false);
  // State to control Supplier select open state
  const [supplierSelectOpen, setSupplierSelectOpen] = React.useState(false);
  const {data:buFilterData} = useGetBusinessUnitGlobalFilter()
  const {data:supplierFilterData} = useGetSAupplierNameGlobalFilter()

  const sortedBuList = React.useMemo(
    () => (buFilterData ? [...buFilterData].sort((a, b) => a.localeCompare(b)) : []),
    [buFilterData]
  );
  const sortedSupplier = React.useMemo(
    () => (supplierFilterData ? [...supplierFilterData].sort((a, b) => a.localeCompare(b)) : []),
    [supplierFilterData]
  );

  // Styled Select for consistent input height/width
  const StyledSelect = styled(Select)({
    height: '38px',
    minWidth: '210px',
    maxWidth: '300px',
    background: '#fff',
    borderRadius: '6',
    fontSize: '15',
  });

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-end',
        gap: 3,
        background: '#fff',
        p: '16px 32px',
        borderRadius: 2,
      }}
    >
      {/* Business Unit */}
      <Box sx={{ display: 'flex',flexDirection:'column',gap:'8px' }}>
        <InputLabel sx={{ fontSize: '12px', color: 'var(--grey-666)',fontWeight:'500' }}>
          Business unit
        </InputLabel>
        <FormControl sx={{ display: 'flex',flexDirection:'row' }}>
          <StyledSelect
            multiple
            value={globalRptFilters.business_unit}
            onChange={e => {
              onChange('business_unit', e.target.value);
            }}
            displayEmpty
            renderValue={(selected: unknown) =>
              Array.isArray(selected) && selected.length
                ? selected.join(', ')
                : <span style={{ color: '#bdbdbd' }}>Select business unit</span>
            }
          >
            {sortedBuList?.map((option,index) => (
              <MenuItem key={index} value={option} sx={{fontSize:'14px',fontWeight:'400',fontFamily:'Manrope',color:'black'}}>
                {option.charAt(0).toUpperCase()+option.slice(1)}
              </MenuItem>
            ))}
          </StyledSelect>
        </FormControl>
      </Box>

      {/* Supplier */}
      <Box sx={{ display: 'flex',flexDirection:'column',gap:'8px' }}>
        <InputLabel sx={{ fontSize: '12px', color: 'var(--grey-666)',fontWeight:'500'}}>
          Supplier
        </InputLabel>
        <FormControl size="small">
          <StyledSelect
            multiple
            value={globalRptFilters.supplier}
            onChange={e => {
              onChange('supplier', e.target.value);
            }}
            displayEmpty
            renderValue={(selected: unknown) =>
              Array.isArray(selected) && selected.length
                ? selected.join(', ')
                : <span style={{ color: '#bdbdbd' }}>Select supplier</span>
            }
          >
            {sortedSupplier?.map((option,index) => (
              <MenuItem key={index} value={option}>
                {option}
              </MenuItem>
            ))}
          </StyledSelect>
        </FormControl>
      </Box>

      {/* Invoice receive date */}
      <Box sx={{ display: 'flex',flexDirection:'column',gap:'8px' }}>
        <InputLabel sx={{ fontSize: '12px', color: 'var(--grey-666)',fontWeight:'500'}}>
          Invoice receive date
        </InputLabel>
        <RangePicker
          value={globalRptFilters.invoiceReceiveDate}
          onChange={dates => onChange('invoiceReceiveDate', dates)}
          style={{ width: '200px', height: '40px',border: '1px solid var(--grey-CCC)', }}
        />
      </Box>

      {/* Invoice generation date */}
      <Box sx={{ display: 'flex',flexDirection:'column',gap:'8px' }}>
        <InputLabel sx={{ fontSize: '12px', color: 'var(--grey-666)',fontWeight:'500'}}>
          Invoice generation date
        </InputLabel>
        <RangePicker
          value={globalRptFilters.invoiceGenerationDate}
          onChange={dates => onChange('invoiceGenerationDate', dates)}
          style={{ width: '200px', height: '40px',border: '1px solid var(--grey-CCC)' }}
        />
      </Box>

      {/* Action buttons */}
      <Box sx={{ display: 'flex', gap: '12px', alignItems: 'center', ml: 2, mb: '2px' }}>
        <Button
          variant="contained"
          disabled={!(globalRptFilters.supplier?.length || globalRptFilters.business_unit?.length || globalRptFilters.invoiceGenerationDate?.length || globalRptFilters.invoiceReceiveDate?.length)}
          onClick={handleGlobalRptFilters}
          sx={{minWidth: '102px', fontSize: '14px', padding: '10px 12px', fontWeight: 600, lineHeight: '18px', height: 'auto'}}
        >
          Apply filters
        </Button>
        <Button
          variant="outlined"
          color="secondary" 
          disabled={!(globalRptFilters.supplier?.length || globalRptFilters.business_unit?.length || globalRptFilters.invoiceGenerationDate?.length || globalRptFilters.invoiceReceiveDate?.length)}
          onClick={handleClear}
          sx={{ fontSize: '14px', fontWeight: 600,}}
        >
          Reset
        </Button>
      </Box>
    </Box>
  );
};

export default ReportingGlobalFilters;
